/** Release toggle names. Kept free of imports so data modules can use them without side effects. */
export const AERO_ENTERPRISE_UPLOAD = 'aero-enterprise-upload';
export const ALL_WORK_ORDERS_SCHEDULE = 'all_work_orders_schedule';
export const BLADE_INTERNAL_SCHEMATIC_VIEW = 'blade_internal_schematic_view';
export const BOP_INSPECTIONS = 'bop_inspections';
export const BULK_UPDATE_PICTURES = 'bulk_update_pictures';
export const COST_MANAGEMENT = 'cost_management';
export const COST_MANAGEMENT_CURRENCY = 'cost_management_currency';
export const CUSTOMIZABLE_DASHBOARD = 'customizable_dashboard';
export const DAMAGES_DB_MAINTENANCE_BANNER = 'damages_db_maintenance_banner';
export const DAMAGE_EDIT_MODAL = 'damage_edit_modal';
export const DAMAGE_INGESTION_V2 = 'damage_ingestion_v2';
export const ENHANCED_INSPECTION_STATUSES = 'enhanced_inspection_statuses';
export const EMAIL_INBOX = 'email_inbox';
export const EXECUTIVE_DASHBOARD = 'executive_dashboard';
export const IDD_COMMENTS = 'idd-comments';
export const INSPECTION_MAP_VIEW = 'inspection_map_view';
export const INSPECTION_UPLOAD_SORT_FILTER_ADDITIONS = 'inspection_upload_sort_filter_additions';
export const INSPECTION_VENDOR_NAMES = 'inspection_vendor_names';
export const IS_360_VIEWER = '360_viewer';
export const IS_360_VIEWER_V2 = '360_viewer_v2';
export const MISSED_INSPECTIONS = 'missed_inspections';
export const MULTI_LANGUAGE = 'multi_language';
export const RELEASE_NOTIFICATION = 'release_notification';
export const RVM_OPTIMIZATIONS = 'rvm_optimizations_2026';
export const SKIP_INSPECTION_TASK_CREATION = 'skip_inspection_task_creation';
export const TASK_LOGS_IN_WORK_ORDERS = 'task_logs_in_work_orders';
export const TEST_RT = 'test_rt';
export const USER_MANAGER = 'user_manager';
export const VENDOR_CREDITS = 'vendor_credits';
export const WORK_CONTAINER_CHANGE_LOG = 'work_container_change_log';
